module.exports = __webpack_public_path__ + "static/media/monthlyincome.aaab0a3a.PNG";